import { usePageSEO } from "@/hooks/usePageSEO";
import WoodstockHeroSection from "./components/HeroSection";
import WoodstockStickyNav from "./components/StickyNav";
import WoodstockProcessingTimeSection from "./components/ProcessingTimeSection";
import WoodstockServicesSection from "./components/ServicesSection";
import WoodstockLocalAreaSection from "./components/LocalAreaSection";
import WoodstockTestimonialsSection from "./components/TestimonialsSection";
import WoodstockAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import WoodstockComparisonSection from "./components/ComparisonSection";
import WoodstockMistakesSection from "./components/MistakesSection";
import WoodstockHowItWorksSection from "./components/HowItWorksSection";
import WoodstockFAQSection, { faqs } from "./components/FAQSection";
import WoodstockHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import WoodstockFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function WoodstockPage() {
  usePageSEO({
    cityName: "Woodstock",
    route: "/cities/woodstock",
    description: "Emergency and expedited passport services in Woodstock, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Cherokee County and north metro Atlanta travelers. Get your emergency passport fast!",
    geoPlacename: "Woodstock, Georgia",
    geoPosition: "34.1015;-84.5194",
    keywords: "expedited passport, emergency passport, Woodstock passport, same day passport Woodstock, fast passport Georgia, Cherokee County passport",
    faqs,
  });

  return (
    <div className="font-sans">
      <WoodstockHeroSection />
      <WoodstockStickyNav />
      <WoodstockProcessingTimeSection />
      <WoodstockServicesSection />
      <WoodstockLocalAreaSection />
      <WoodstockTestimonialsSection />
      <WoodstockAcceptanceFacilitiesSection />
      <WoodstockComparisonSection />
      <WoodstockMistakesSection />
      <WoodstockHowItWorksSection />
      <WoodstockFAQSection />
      <WoodstockHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/woodstock" state="GA" />
      <WoodstockFinalCTA />
    </div>
  );
}